import request from '@/utils/request'

export function getRequestDocuments(data) {
  return request({
    url: `/api/requestDocuments/getRequestDocuments`,
    method: 'get',
    data,
  })
}
export function getReports(data) {
  return request({
    url: `/api/requestDocuments/getReports`,
    method: 'get',
    data,
  })
}
export function getWorksputFileList(data) {
  return request({
    url: `/api/requestDocuments/getWorksputFileList`,
    method: 'get',
    data,
  })
}
/* ***********************************    協力会社-原価見積書（工程表）提出
 *********************************** */

// 提出書類-書類マスト情報を取得
export function requestDocumentInit(data) {
  return request({
    url: `/api/requestDocuments/doc/many`,
    method: 'post',
    data,
  })
}
// 提出書類リストのファイル削除
export function requestDocumentsDelete(data) {
  return request({
    url: `/api/requestDocuments/delete`,
    method: 'post',
    data,
  })
}
// 提出書類リストのファイルダウンロード
export function requestDocumentsDownload(data) {
  return request({
    url: `/api/requestDocuments/download`,
    method: 'post',
    data,
  })
}
// 書類リスト情報を取得
export function requestDocumentsRelation(data) {
  return request({
    url: `/api/requestDocuments/reqDoc/many`,
    method: 'post',
    data,
  })
}

// 提出書類リストのファイルアップロード
export function requestDocumentsUpload(data) {
  return request({
    url: `/api/requestDocuments/upload`,
    method: 'post',
    data,
  })
}
// 書類一括ダウンロード
export function requestDocumentDownloadAll(data) {
  return request({
    url: `/api/requestDocuments/downloadAll`,
    method: 'post',
    data,
  })
}
export function updateBook(data) {
  return request({
    url: `/api/requestDocuments/partner/update`,
    method: 'post',
    data,
  })
}
/* ***********************************    協力会社-工事（作業）報告書提出
 *********************************** */
// 報告書SC報告書ー書類を取得
export function scReportInit(data) {
  return request({
    url: `/api/scReport/doc/list`,
    method: 'post',
    data,
  })
}
// 報告書削除
export function scReportDelete(data) {
  return request({
    url: `/api/scReport/delete`,
    method: 'post',
    data,
  })
}
//報告書ダウンロード
export function scReportDownload(data) {
  return request({
    url: `/api/scReport/download`,
    method: 'post',
    data,
  })
}
//SC報告書リスト取得
export function querySc(data) {
  return request({
    url: `/api/scReport/many/querySc`,
    method: 'post',
    data,
  })
}
//SC報告書リスト取得
export function scReportUpload(data) {
  return request({
    url: `/api/scReport/upload`,
    method: 'post',
    data,
  })
}
//報告書一括ダウンロード
export function downloadAll(data) {
  return request({
    url: `/api/scReport/downloadAll`,
    method: 'post',
    data,
  })
}
//報告書サンプル一括ダウンロード
export function downloadSample(data) {
  return request({
    url: `/api/scReport/downloadSample`,
    method: 'post',
    data,
  })
}
